import {Group} from "../../schema";
import {SortInput} from "../../ui/sortbutton";
import {compareByTextAndTrailingNumber} from "../../utils";
import {AccountGroupSortField} from "./groups";

export function sortGroups(groups: Group[], sort: SortInput<AccountGroupSortField>): Group[] {
  const sortedGroups = [...groups];

  const compare = (a?: string | null, b?: string | null, useTrailingNumbers = false): number => {
    if (!a && !b) return 0;
    if (!a) return -1;
    if (!b) return 1;

    return useTrailingNumbers ? compareByTextAndTrailingNumber(a, b) : a.localeCompare(b);
  };

  if (sort.field === "NAME") {
    sortedGroups.sort((a, b) => {
      const result = compare(a.name, b.name, true);
      return sort.direction === "ASC" ? result : -result;
    });
  } else if (sort.field === "CODE_NAME") {
    sortedGroups.sort((a, b) => {
      const result = compare(a.code, b.code, true);
      return sort.direction === "ASC" ? result : -result;
    });
  }

  return sortedGroups;
}
